import styled from '@emotion/styled'

const Container = styled.div`
  & {
    text-align: center;
    position: relative;
    cursor: pointer;
    display: inline-block;
    padding: 0;
    margin: 0;
    border: none;
    transition: ${({ theme }) => theme.style.transitionTime[400]} opacity;
  }

  &:hover {
    opacity: ${({ theme }) => theme.style.opacity[700]};
  }

  &:focus {
    opacity: ${({ theme }) => theme.style.opacity[500]};
  }

  & > * {
    position: relative;
    z-index: 1;
  }

  & > figure {
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }

  .anchor-underline {
    background: transparent;
    border: none;
    border-bottom: 1px solid currentColor;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: calc(0.5em - 4px);
    transition: ${({ theme }) => theme.style.transitionTime[400]} opacity;
  }
`

export default Container
